import { render, staticRenderFns } from "./guanqiaRentention.vue?vue&type=template&id=fb3054f8&"
import script from "./guanqiaRentention.vue?vue&type=script&lang=js&"
export * from "./guanqiaRentention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3054f8')) {
      api.createRecord('fb3054f8', component.options)
    } else {
      api.reload('fb3054f8', component.options)
    }
    module.hot.accept("./guanqiaRentention.vue?vue&type=template&id=fb3054f8&", function () {
      api.rerender('fb3054f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/guanqia/guanqiaRentention.vue"
export default component.exports